'use strict';

require('./KayleeService');
//var log = require('../../log/Log').channel('GenericDeviceService');

/* global AveoDevice */
/* global AveoPermissions */

angular.module('inara').factory('GenericDeviceService', GenericDeviceService);

GenericDeviceService.$inject = ['$q', '$timeout', 'KayleeService'];

function GenericDeviceService($q, $timeout, KayleeService) {
    return {
        initialize: initialize,
        name: 'generic',
        caps: {
            hasAllowOtaUpgrade: false,
            hasBattery: false,
            hasKioskModeEnable: false,
            hasRestartDevice: false,
            hasRestartInara: true,
        },
        getFactoryInstallChecklist: getFactoryInstallChecklist,
        getSerialNumber: getSerialNumber,
        requiredPermissions: [
            'ACCESS_COARSE_LOCATION',
            'ACCESS_FINE_LOCATION',
            'READ_EXTERNAL_STORAGE',
            'WRITE_EXTERNAL_STORAGE',
        ],
    };

    function getFactoryInstallChecklist() {
        return [{
            name: 'Location permissions',
            getState: function() {
                return AveoPermissions.checkPermissions([ 'ACCESS_COARSE_LOCATION', 'ACCESS_FINE_LOCATION' ])
                .then(function(hasPermission) {
                    for (var i = 0; i < hasPermission.length; i++) {
                        if (!hasPermission[i]) return 'no';
                    }

                    return 'yes';
                });
            },
        }, {
            name: 'Storage permissions',
            getState: function() {
                return AveoPermissions.checkPermissions([ 'READ_EXTERNAL_STORAGE', 'WRITE_EXTERNAL_STORAGE' ])
                .then(function(hasPermission) {
                    for (var i = 0; i < hasPermission.length; i++) {
                        if (!hasPermission[i]) return 'no';
                    }

                    return 'yes';
                });
            },
        }, {
            name: 'Developer options disabled',
            getState: function() {
                return AveoDevice.getDeveloperOptions()
                .then(function(devOptions) {
                    var adbEnabled = devOptions.adbEnabled === '1';
                    var devEnabled = devOptions.developmentSettingsEnabled === '1';
                    return adbEnabled || devEnabled ? 'no' : 'yes';
                });
            },
        }];
    }

    function getSerialNumber() {
        return device.uuid;
    }

    function initialize(pinfo) {
        return $q.resolve();
    }
}

module.exports = GenericDeviceService;
